"use client";

import { useState } from "react";
import { css, cx } from "styled-system/css";
import { cf } from "@/components/brand/sfturnos-styles";

export function PublicBookingLink({ href, label }: { href: string; label: string }) {
  const [done, setDone] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(href);
      setDone(true);
      setTimeout(() => setDone(false), 2000);
    } catch {
      setDone(false);
    }
  }

  return (
    <div className={cx(cf.dashSurface, css({ p: "5" }))}>
      <p className={css({ fontSize: "xs", color: "#64748b", mb: "2" })}>{label}</p>
      <div className={css({ display: "flex", flexDir: { base: "column", sm: "row" }, gap: "3", alignItems: { sm: "center" } })}>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={css({
            fontSize: "sm",
            color: "#4f46e5",
            wordBreak: "break-all",
            textDecoration: "underline",
            _hover: { color: "#4338ca" },
          })}
        >
          {href}
        </a>
        <button
          type="button"
          onClick={() => void copy()}
          className={css({
            flexShrink: 0,
            px: "3",
            py: "2",
            rounded: "lg",
            fontSize: "sm",
            fontWeight: "semibold",
            color: "#334155",
            borderWidth: "1px",
            borderColor: "#e2e8f0",
            bg: "#f8fafc",
            cursor: "pointer",
            _hover: { bg: "#f1f5f9", borderColor: "#cbd5e1" },
          })}
        >
          {done ? "Copiado" : "Copiar enlace"}
        </button>
      </div>
    </div>
  );
}
